module.exports = __webpack_public_path__ + "static/img/advantage.e87f53e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/advantage.png
// module id = 4VKk
// module chunks = 1